import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import useApi from '@/hooks/useApi';
import { toDayjsLocale } from '@/utils/dayjsLocale';
import Row from './Row';
import SkeletonRow from './SkeletonRow';
import styles from './RecentActivity.module.scss';

dayjs.extend(relativeTime);

const SKELETON_ROW_COUNT = 4;

const RecentActivity = () => {
  const { t, i18n } = useTranslation(['common']);
  const [load, { response, loading }] = useApi('dashboard.recentActivity');

  useEffect(() => {
    void load();
  }, [load]);

  const items = response?.data ?? [];
  const isLoading = loading === true && !response;
  const isEmpty = !isLoading && items.length === 0;

  if (isEmpty) {
    return null;
  }

  const dayjsLocale = toDayjsLocale(i18n.language);

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>
        {t('common:dashboard.recentActivity.title')}
      </h2>
      <ul className={styles.list}>
        {isLoading
          ? Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
              <SkeletonRow key={index} />
            ))
          : items.map((item) => (
              <Row key={item.id} item={item} dayjsLocale={dayjsLocale} t={t} />
            ))}
      </ul>
    </section>
  );
};

export default RecentActivity;
